import { Injectable } from "@angular/core";

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { AssignmentsService } from "@carnegie-learning/data-access-angular-passport";
import * as studentMetricsActions from "../actions/student-metrics.action";

@Injectable()
export class StudentMetricsEffects {
    constructor(
        private actions$: Actions,
        private assignmentsService: AssignmentsService
    ) {}

    loadStudentMetrics$ = createEffect(() =>
        this.actions$.pipe(ofType(studentMetricsActions.loadStudentMetrics)).pipe(
            map((action) => action),
            switchMap(payload => {
                return this.assignmentsService
                    .getStudentMetrics(payload.courseID, payload.userID)
                    .pipe(
                        map(
                            student =>
                                studentMetricsActions.loadStudentMetricsSuccess(
                                    {payload:student}
                                )
                        ),
                        catchError(error =>
                            of(
                                studentMetricsActions.loadStudentMetricsFail(
                                    error
                                )
                            )
                        )
                    );
            })
        )
    );
}
